import React from "react";
import { graphql } from "gatsby";
import g from "glamorous";
import { css } from "glamor";
import Layout from "../components/layout";
import ContactSidebar from "../components/ContactSidebar-en";
import AdresseSidebar from "../components/AdresseSidebar-en";
import Accordion from "../components/Accordion-en";
import AvantApresBlock from "../components/AvantApresBlock-en";
import KeybodyBlock from "../components/KeybodyBlock-en";
import VideoBlock from "../components/VideoBlock-en";
import NewsBlock from "../components/NewsBlock-en";
import ASavoir from "../components/ASavoir-en";
import Bio from "../components/Bio-en";
import Menu from "../components/Menu-en";
import Footer from "../components/Footer-en";
import Social from "../components/Social-en";
import { FaHome } from "react-icons/fa";
import Img from "gatsby-image";
import { Link } from "gatsby";
import { Container, Row, Col } from "glamorous-grid";
import { Helmet } from "react-helmet";
import Carrousel from "../components/Carrousel-en";
import _ from "lodash";

export default function Template({ data }) {
  const { markdownRemark, allMarkdownRemark } = data; // data.markdownRemark holds our post data

  const { frontmatter, html } = markdownRemark;

  const autresPages = _.remove(allMarkdownRemark.edges, function (arg) {
    return arg.node.frontmatter.path !== frontmatter.path;
  });

  const Wrapper = g.div({
    maxWidth: `1000px`,
    margin: `0 auto 2.5em`,
  });

  const Tag = g.div({
    textAlign: `center`,
    color: `black`,
    fontSize: `.8em`,
    fontWeight: `400`,
    marginTop: `2.4em`,
    textTransform: `uppercase`,
    letterSpacing: `.08em`,
    "@media(max-width: 767px)": {
      fontSize: `.85em`,
      marginTop: `1.6em`,
    },
  });

  const Title = g.h1({
    textAlign: `center`,
    fontSize: `36px`,
    color: `#3c4d68`,
    maxWidth: `720px`,
    margin: `.1em auto .6em`,
    fontVariant: `none`,
    fontWeight: `600`,
    letterSpacing: `.01em`,
    lineHeight: `49px`,
    "@media(max-width: 767px)": {
      fontSize: `25px`,
      lineHeight: `32px`,
    },
  });

  const Tags = g.div({
    marginBottom: `30px`,
    textAlign: `right`,
  });

  const TagsItem = g.span({
    display: `inline-block`,
    textTransform: `capitalize`,
    "&::after": {
      color: `#333`,
      paddingRight: `3px`,
    },
    "&::last-of-type": {
      color: `red`,
    },
    ":hover": {
      textDecoration: `underline`,
    },
    ":focus": {},
  });

  const Breadcrumb = g.ul({
    fontSize: `13px`,
    lineHeight: `20px`,
    marginLeft: `0 !important`,
    marginTop: `0`,
    marginBottom: `10px !important`,
    fontWeight: `500`,
    letterSpacing: `.015em`,
  });

  const BreadcrumbItem = g.li({
    display: `inline`,
    "&:first-of-type": {
      "&::before": {
        content: `none`,
      },
    },
    "&::before": {
      content: `/`,
      padding: `0 .5em`,
    },
  });

  const cssBreadcrumbLink = css({
    color: `#3c4d68`,
    borderBottom: `none`,
  });

  const TranslationBlock = g.div({
    fontSize: `.9em`,
    margin: `2.5em 0`,
    lineHeight: `1.55em`,
    fontStyle: `italic`,
  });

  css.global(".gatsby-resp-image-figcaption", {
    textAlign: "center",
    fontStyle: `italic`,
    fontSize: `.85em`,
    lineHeight: `1.45em`,
    marginTop: `.5em`,
  });

  css.insert('.tagsitem:after { content: ","; padding-right: 5px;  }');
  css.insert('.tagsitem:last-of-type:after { content: ""  }');

  return (
    <Layout>
      <g.Div id="page-wrap" margin={`0 auto`} backgroundColor={`#fcfcfc`}>
        <Helmet>
          <html lang="en" />
          <title>{frontmatter.metaTitle}</title>
          <meta name="description" content={frontmatter.metaDescription} />
          <meta
            property="og:url"
            content={`https://www.dr-kron.com${frontmatter.path}`}
          />
          <meta property="og:type" content="article" />
          <meta property="og:title" content={frontmatter.title} />
          <meta
            property="og:description"
            content={frontmatter.metaDescription}
          />
          {frontmatter.image !== "none" && (
            <meta
              property="og:image"
              content={`https://www.dr-kron.com${frontmatter.image.childImageSharp.fluid.src}`}
            />
          )}
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:width" content="800" />
          <meta property="og:image:height" content="455" />

          <meta property="og:locale" content="en_US" />
          <meta property="fb:app_id" content="402235436975681" />

          {frontmatter.pathFr !== "/" && (
            <link
              rel="alternate"
              hreflang="fr"
              href={`https://www.dr-kron.com${frontmatter.pathFr}`}
            />
          )}

          <script type="application/ld+json">{`
        {
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "News",
              "item": "https://www.dr-kron.com/en/news/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "${frontmatter.title}",
              "item": "https://www.dr-kron.com${frontmatter.path}"
            }]
        }
    `}</script>
        </Helmet>
        <Menu pathFr={frontmatter.pathFr} />

        <Wrapper>
          <article data-pagefind-body data-pagefind-weight="0.3">
            <Container css={{ padding: `0 15px !important` }}>
              <Row>
                <Col>
                  <div className="page-post">
                    <Link to="/en/news/" css={{ textDecoration: `none` }}>
                      <Tag>news</Tag>
                    </Link>

                    <Title>{frontmatter.title}</Title>

                    {frontmatter.image !== "none" && (
                      <Img
                        fluid={frontmatter.image.childImageSharp.fluid}
                        css={{
                          marginBottom: `2rem`,
                          "@media only screen and (max-width: 600px)": {
                            marginLeft: `calc(50% - 49.99vw)`,
                            marginRight: `calc(50% - 49.99vw)`,
                            marginBottom: `1em`,
                          },
                        }}
                        alt={frontmatter.title}
                      />
                    )}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={{ xs: 12 / 12, lg: 69 / 100 }}>
                  <Breadcrumb>
                    <BreadcrumbItem>
                      <Link to="/en/" {...cssBreadcrumbLink} title="Homepage">
                        <FaHome
                          css={{
                            fontSize: `1.2em`,
                            paddingBottom: `.2em`,
                            transform: `translateY(5px)`,
                          }}
                        />
                      </Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                      <Link to="/en/news/" {...cssBreadcrumbLink}>
                        News
                      </Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem>{frontmatter.title}</BreadcrumbItem>
                  </Breadcrumb>

                  <div
                    className="page-content"
                    dangerouslySetInnerHTML={{ __html: html }}
                  />
                  <TranslationBlock>
                    <p>
                      <span
                        role="img"
                        aria-label="English flag - drapeau anglais"
                      >
                        🇬🇧
                      </span>
                      <b>About the translation:</b> Parts of the English
                      version of this website were translated using computer
                      generated translation. If you notice a significant error
                      or if you have any doubt regarding the medical
                      information provided,{" "}
                      <Link to="/en/contact-us/">
                        please send us a message
                      </Link>
                      .
                    </p>
                  </TranslationBlock>
                  <Social path={frontmatter.path} title={frontmatter.title} />
                  <Tags>
                    <div
                      css={{
                        fontSize: `0.85em`,
                        fontWeight: `600`,
                        textTransform: `uppercase`,
                        display: `inline-block`,
                        paddingRight: `5px`,
                      }}
                    >
                      Tags:
                    </div>
                    {frontmatter.tags.map((tag) => (
                      <Link
                        to={`/en/${tag.replace(/\s+/g, "-")}/`}
                        css={{
                          textDecoration: `none`,
                          fontSize: `.85em`,
                          color: `#3c4d68`,
                          fontWeight: `500`,
                        }}
                        className="tagsitem"
                      >
                        <TagsItem>{tag}</TagsItem>
                      </Link>
                    ))}
                  </Tags>
                  <Bio />
                </Col>
                <Col span={{ xs: 12 / 12, lg: 31 / 100 }}>
                  <aside>
                    <ContactSidebar about={frontmatter.about} />
                    <AdresseSidebar />
                    <Accordion />
                    <AvantApresBlock />
                    <KeybodyBlock />
                    <VideoBlock />
                    <NewsBlock />
                    <ASavoir />
                  </aside>
                </Col>
              </Row>
            </Container>
          </article>
        </Wrapper>
        <Carrousel other={autresPages} />

        <Footer />
      </g.Div>
    </Layout>
  );
}

export const pageQuery = graphql`
  query NewsPostByPathEn($path: String!, $tag: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        pathFr
        title
        tags
        about
        dateDisplay
        metaTitle
        metaDescription
        image {
          absolutePath
          childImageSharp {
            resize(width: 1500, height: 1500) {
              src
            }
            fluid(maxWidth: 952) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
    allMarkdownRemark(
      limit: 28
      filter: { frontmatter: { tags: { eq: $tag } } }
    ) {
      edges {
        node {
          frontmatter {
            shortTitle
            excerpt
            path
            image {
              childImageSharp {
                fluid(maxWidth: 367) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
          }
        }
      }
    }
  }
`;
